import React from 'react';
import { useParams, Navigate } from 'react-router-dom';

interface WorkspaceRedirectProps {
  path: string;
}

export function WorkspaceRedirect({ path }: WorkspaceRedirectProps) {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  
  // For backward compatibility: redirect /w/:workspaceId/* to /:workspaceSlug/*
  // Note: This assumes workspaceId can be used as slug, which may not always work
  // The WorkspaceContext will handle proper resolution if the slug doesn't match
  const redirectTo = `/${workspaceId}/${path}`;
  
  return <Navigate to={redirectTo} replace />;
}